import React from 'react';
import PropTypes from 'prop-types';
import { format, isWithinInterval, isAfter } from 'date-fns';
import SelectedIcon from 'products/nomad_insurance/assets/img/claims/claim-radio-selected.svg';
import EmptyIcon from 'products/nomad_insurance/assets/img/claims/claim-radio-empty.svg';
import { Container } from './styled';
import { Text } from '../../styled';

const ContractItem = ({ contract, selectedContract, setSelectedContract }) => {
  const startDate = new Date(contract.startDate);
  const endDate = new Date(contract.endDate);
  const startDateFormatted = format(startDate, 'MM/dd/yyyy');
  const endDateFormatted = format(endDate, 'MM/dd/yyyy');

  const isTodayWithinInterval =
    !isAfter(startDate, endDate) &&
    isWithinInterval(new Date(), {
      start: startDate,
      end: endDate
    });

  const isFutureContract = isAfter(new Date(contract.startDate), new Date());

  const endDateText = isTodayWithinInterval ? 'now' : endDateFormatted;

  const isSelected = contract.policyID === selectedContract?.policyID;

  const handleSelect = () => {
    setSelectedContract(contract);
  };

  let policyText = 'Past policy';
  if (isTodayWithinInterval) {
    policyText = 'Current policy';
  } else if (isFutureContract) {
    policyText = 'Future policy';
  }

  return (
    <Container onClick={handleSelect}>
      <img src={isSelected ? SelectedIcon : EmptyIcon} alt="radio button" />
      <Text>{`${policyText} (${startDateFormatted} - ${endDateText})`}</Text>
    </Container>
  );
};

ContractItem.propTypes = {
  selectedContract: PropTypes.object,
  setSelectedContract: PropTypes.func,
  contract: PropTypes.object
};

export default ContractItem;
